module.exports = __webpack_public_path__ + "img/box5.3e478a4f.png";